/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Preset_Deleted_ToastInputs */



/**
* | output |
* | --- |
* | "Preset deleted successfully" |
*
* @param {Styles_Preset_Deleted_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_preset_deleted_toast = /** @type {((inputs?: Styles_Preset_Deleted_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Preset_Deleted_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Preset supprime avec succes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Voreinstellung erfolgreich gelöscht")
	if (locale === "it") return /** @type {LocalizedString} */ ("Preimpostazione eliminata con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предварительно настроенные параметры успешно удалены.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Preajuste eliminado exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("预设已成功删除")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プリセットが正常に削除されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रीसेट सफलतापूर्वक हटा दिया गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Predefinição excluída com sucesso")
	return /** @type {LocalizedString} */ ("Preset deleted successfully")
});